// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

function getPathsCmsUrl(locale) {
  return Config$PorterinUtils.cms_url + "/api/website-pnms?pagination[pageSize]=600";
}

function getDataCmsUrl(city, locale) {
  return Config$PorterinUtils.cms_url + ("/api/website-pnm/" + city + "?populate=deep");
}

function getPnMCampaignCmsUrl(param) {
  return Config$PorterinUtils.cms_url + "/api/website-pnm-campaign-microsite?populate=deep";
}

function getShiftReqSubmissionUrl(param) {
  return Config$PorterinUtils.getPnMUrl(undefined) + "/sr/record_basic_details";
}

function getPnmOrderLeadCreationUrl(param) {
  return Config$PorterinUtils.getPnMUrl(undefined) + "lms/order_interests/record_v2";
}

function getBoundaryValidatorUrl(param) {
  return Config$PorterinUtils.getPnMUrl(undefined) + "geos/validate_boundaries";
}

function getSubmitPnMShiftReqLocationDetailsUrl(param) {
  return Config$PorterinUtils.getPnMUrl(undefined) + "sr/record_location_details";
}

export {
  getPathsCmsUrl ,
  getDataCmsUrl ,
  getPnMCampaignCmsUrl ,
  getShiftReqSubmissionUrl ,
  getPnmOrderLeadCreationUrl ,
  getBoundaryValidatorUrl ,
  getSubmitPnMShiftReqLocationDetailsUrl ,
}
/* Config-PorterinUtils Not a pure module */
